(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var toggle = document.querySelector('.header__search-toggle');
    var panel = document.getElementById('header-search-panel');
    if (!toggle || !panel) return;
    var input = panel.querySelector('[data-search-input]');
    function open() { panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); if (input) input.focus(); }
    function close() { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
    toggle.addEventListener('click', function () { panel.hidden ? open() : close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var mediaItems = document.querySelectorAll('.pdp__media');
    var thumbs = document.querySelectorAll('.pdp__thumb');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.dataset.mediaId;
        mediaItems.forEach(function (m) {
          var on = m.dataset.mediaId === id;
          m.classList.toggle('is-active', on);
          if (!on) { var v = m.querySelector('video'); if (v) { v.pause(); } }
        });
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
    document.querySelectorAll('.pdp__qty').forEach(function (wrap) {
      var input = wrap.querySelector('.pdp__qty-input');
      wrap.querySelectorAll('.pdp__qty-btn').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = b.dataset.qty === 'plus' ? v + 1 : Math.max(1, v - 1);
          input.value = v;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
